<script>
	module.exports = {
		props: {
			banner: {
				default: null
			},
			title: {
				default: null
			},
			subHeadline: {
				default: null
			},
			byline: {
				default: null
			},
			newsDate: {
				default: null
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'mixins/typography';

	.news-header {
		margin-top: 1rem;
		.news-headline {
			margin-top: 0rem;
		}
		.news-masthead,
		.news-subheadline {
			margin-bottom: 1rem;
		}
		.news-subheadline {
			font-family: $helvetica;
			font-size: 1.1rem;
			font-weight: normal;
			margin-top: 0rem;
		}
		.news-byline {
			font-style: italic;
		}
		.news-date {
			font-family: $helvetica;
		}
	}
</style>
<template>
	<div class="news-header">
		<div
			class="news-masthead"
			v-if="banner">
			<figure class="article-news-banner">
				<img v-bind:src="banner" />
			</figure>
		</div>
		<h2 class="news-headline">{{ title }}</h2>
		<h3 class="news-subheadline">{{ subHeadline }}</h3>
		<div class="news-byline">By {{ byline }}</div>
		<div class="news-date">{{ (newsDate / 1000) | date }}</div>
	</div>
</template>
